import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoanApiService } from '../../services/loan-api.service';

@Injectable({
  providedIn: 'root'
})
export class LeadGuard implements CanActivate {
  constructor(private router: Router, private loanApiService: LoanApiService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const leadId = +route.params.leadId;
    const url = state.url.split('/');
    if (isNaN(leadId)) {
      url.splice(url.length - 2, 2);
      return this.router.createUrlTree(url);
    }
    return this.loanApiService.checkLeadStatus(leadId).pipe(
      map((res) => {
        if (res.isConverted) {
          url.splice(url.length - 2, 2, res.LoanId);
          return this.router.createUrlTree(url);
        } else {
          return true;
        }
      })
    );
  }
}
